var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTaxonomies)?_c('div',{staticClass:"taxonomy module"},_vm._l((_vm.filledIn),function(tag){return _c('div',{key:tag.id,staticClass:"tag"},[_vm._v(" Programs: "+_vm._s(tag.text)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }